export const chatKeys = {
  all: ['chats'] as const,
  history: (session: string) => ['chats', session, 'history'] as const,
  version: ['version'] as const,
};
